<template>
  <div class="" id="auth">
        <!--<div class="container-fluid" id="auth">-->

    <!--<router-view name="header-top"></router-view>-->
    <!--<div class="container-fluid">-->
      <h2 class="text-center"></h2>
      <transition name="fade">
        <router-view></router-view>
        <!--<router-view name="header-bottom"></router-view>-->
      </transition>
    <!--</div>-->
  </div>

</template>

<script>
export default {
  computed: {
    isAuth: function() {
      return this.$auth.loggedIn();
    }
  },
  name: "auth"
}
</script>

<style>

</style>





// WEBPACK FOOTER //
// Auth.vue?78bcbcbc